var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.shouldShowGuide && !_vm.isChatbotPageActive && !_vm.allCompleted
        ? _c(
            "div",
            {
              ref: "setupGuideContainer",
              staticClass: "setup-guide-container",
              class: { expanded: _vm.showDetails },
              style: _vm.containerStyle,
            },
            [
              _c(
                "div",
                {
                  staticClass: "floating-button",
                  on: {
                    mousedown: _vm.onDragStart,
                    click: _vm.onFloatingButtonClick,
                  },
                },
                [
                  _c("div", { staticClass: "progress-indicator" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "32",
                          height: "32",
                          viewBox: "0 0 48 48",
                        },
                      },
                      [
                        _c("circle", {
                          staticClass: "progress-bg",
                          attrs: {
                            cx: "24",
                            cy: "24",
                            r: "20",
                            "stroke-width": "4",
                          },
                        }),
                        _vm._v(" "),
                        _c("circle", {
                          staticClass: "progress-bar",
                          attrs: {
                            cx: "24",
                            cy: "24",
                            r: "20",
                            "stroke-width": "4",
                            "stroke-dasharray": _vm.circumference,
                            "stroke-dashoffset": _vm.progressOffset,
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "progress-text" }, [
                      _vm._v(_vm._s(_vm.completionPercentage) + "%"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.showDetails
                    ? _c("div", { staticClass: "guide-title" }, [
                        _vm._v(_vm._s(_vm.$t("setupWizard.supsisSetupGuide"))),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("i", { staticClass: "material-icons toggle-icon" }, [
                    _vm._v(
                      _vm._s(
                        _vm.showDetails
                          ? "keyboard_arrow_down"
                          : "keyboard_arrow_up"
                      )
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm.showDetails
                ? _c("div", { staticClass: "setup-panel" }, [
                    _c("div", { staticClass: "panel-header" }, [
                      _c("p", { staticClass: "font-weight-bold" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("setupWizard.supsisSetupGuideDescription")
                          )
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "setup-items" },
                      _vm._l(_vm.enabledSetupItems, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: item.key,
                            staticClass: "setup-item",
                            class: { completed: item.completed },
                          },
                          [
                            _c("div", { staticClass: "item-status" }, [
                              item.completed
                                ? _c("div", { staticClass: "completed-icon" }, [
                                    _vm._v("✓"),
                                  ])
                                : _c("div", { staticClass: "step-number" }, [
                                    _vm._v(_vm._s(index + 1)),
                                  ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "item-content" }, [
                              _c("span", [_vm._v(_vm._s(item.showItem))]),
                              _vm._v(" "),
                              _c("h4", [_vm._v(_vm._s(item.title))]),
                              _vm._v(" "),
                              _c("p", [_vm._v(_vm._s(item.description))]),
                              _vm._v(" "),
                              !item.completed
                                ? _c(
                                    "div",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.startTour(item.key)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          staticClass: "setup-link",
                                          attrs: {
                                            to: { path: "/" + item.routerUrl },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.$t("setupWizard.goToSetup")
                                              ) +
                                              "\n                            "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "footer" }, [
                      _c("span", { staticClass: "footer-text" }, [
                        _c("i", { staticClass: "material-icons footer-icon" }, [
                          _vm._v("info"),
                        ]),
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.$t(
                                "setupWizard.completionPercentageDescription",
                                { percentage: _vm.completionPercentage }
                              )
                            ) +
                            "\n                "
                        ),
                      ]),
                    ]),
                  ])
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showTour
        ? _c("setup-tour", {
            attrs: { steps: _vm.tourSteps, "is-active": _vm.showTour },
            on: { "tour-finished": _vm.onTourFinished },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("finish-tour-modal", {
        attrs: {
          "is-visible": _vm.showFinishModal,
          "tour-key": _vm.currentTourKey,
        },
        on: { close: _vm.closeFinishModal },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }